var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#505050",
  d: "M9.6,37.4h25.8c0.2,0,0.4-0.2,0.4-0.4v-2.6V22.2V8c0-0.2-0.2-0.4-0.4-0.4H9.6C9.4,7.6,9.2,7.8,9.2,8v1.2 v12.9V37C9.2,37.2,9.4,37.4,9.6,37.4z M12.1,10.1h10.1v12H12.1v-2.9V10.1z M32.9,21.5v0.6H22.8v-10v-2h10.1V21.5z M22.8,25v-2.1 h10.1v11.5v0.6H22.8V25z M22.2,22.9v12H12.1v-12H22.2z"
}), /*#__PURE__*/React.createElement("rect", {
  x: 12.1,
  y: 22.9,
  fill: "#FFFFFF",
  width: 10.1,
  height: 12
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M12.1,22.1h10.1v-12H12.1v9.2V22.1z M15.1,19.4l2.1-2.2h0.5c0.2,0.2,0.2,0.4,0,0.5l-2.1,2.2h-0.5 C14.9,19.7,14.9,19.5,15.1,19.4z M14.3,16.5l2.2-2.2c0.2-0.1,0.3-0.1,0.5,0c0.1,0.2,0.1,0.4,0,0.6l-2.2,2.2h-0.2L14.3,17 C14.2,16.8,14.2,16.7,14.3,16.5z M19.9,15.1c0.1,0.1,0.1,0.4,0,0.5L18.4,17h-0.5c-0.1-0.2-0.1-0.3,0-0.5l1.5-1.4 C19.5,14.9,19.7,14.9,19.9,15.1z M19.1,12.2C19.1,12.2,19.2,12.3,19.1,12.2c0.2,0.2,0.1,0.4,0,0.5l-1.4,1.5h-0.2l-0.3-0.1 c-0.1-0.1-0.1-0.4,0-0.5l1.4-1.4C18.8,12,19,12,19.1,12.2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#FFFFFF",
  d: "M32.9,34.9v-0.6V22.9H22.8V25v10H32.9z M28,29.4L28,29.4c0.1-0.1,0.2-0.1,0.2-0.1c0.2,0.1,0.3,0.3,0.3,0.5 L26.3,32c0,0.1-0.1,0.1-0.2,0.1h-0.3c-0.1-0.2-0.1-0.3,0-0.5L28,29.4z M28.7,28.7l1.4-1.4c0.2-0.2,0.3-0.1,0.5,0 c0.2,0.1,0.2,0.3,0,0.5l-1.4,1.4h-0.5C28.6,29.1,28.6,28.8,28.7,28.7z M27.8,27.2l-2.2,2.1h-0.2h-0.3c-0.1-0.1-0.1-0.4,0-0.5 l2.2-2.1c0.1-0.2,0.3-0.2,0.5,0C27.9,26.8,27.9,27.1,27.8,27.2z M28,25.9l1.4-1.4c0.1-0.1,0.4-0.1,0.5,0c0,0,0.1,0.1,0.1,0.1 c0.1,0.1,0.1,0.3-0.1,0.4l-1.4,1.5h-0.3H28c0,0,0,0,0,0C27.8,26.3,27.8,26,28,25.9z"
}), /*#__PURE__*/React.createElement("polygon", {
  fill: "#FFFFFF",
  points: "22.8,10.1 22.8,12.1 22.8,22.1 32.9,22.1 32.9,21.5 32.9,10.1  "
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A1A1A1",
  d: "M14.6,17.1h0.2l2.2-2.2c0.1-0.2,0.1-0.4,0-0.6c-0.2-0.1-0.3-0.1-0.5,0l-2.2,2.2c-0.1,0.2-0.1,0.3,0,0.5 L14.6,17.1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A1A1A1",
  d: "M18.6,12.2l-1.4,1.4c-0.1,0.1-0.1,0.4,0,0.5l0.3,0.1h0.2l1.4-1.5c0.1-0.1,0.2-0.3,0.1-0.4 c0,0-0.1-0.1-0.1-0.1C19,12,18.8,12,18.6,12.2z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A1A1A1",
  d: "M15.6,19.9l2.1-2.2c0.2-0.1,0.2-0.3,0-0.5h-0.5l-2.1,2.2c-0.2,0.1-0.2,0.3,0,0.5H15.6z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A1A1A1",
  d: "M17.9,17h0.5l1.5-1.4c0.1-0.1,0.1-0.4,0-0.5c-0.2-0.2-0.4-0.2-0.5,0l-1.5,1.4C17.8,16.7,17.8,16.8,17.9,17z "
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A1A1A1",
  d: "M27.8,26.7c-0.2-0.2-0.4-0.2-0.5,0l-2.2,2.1c-0.1,0.1-0.1,0.4,0,0.5h0.3h0.2l2.2-2.1 C27.9,27.1,27.9,26.8,27.8,26.7z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A1A1A1",
  d: "M28,26.5h0.2h0.3l1.4-1.5c0.1-0.1,0.2-0.3,0.1-0.4c0,0-0.1-0.1-0.1-0.1c-0.1-0.1-0.4-0.1-0.5,0L28,25.9 C27.8,26,27.8,26.3,28,26.5C28,26.5,28,26.5,28,26.5z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A1A1A1",
  d: "M25.8,32.1h0.3c0.1,0,0.2,0,0.2-0.1l2.2-2.2c0.1-0.2-0.1-0.4-0.3-0.5c-0.1,0-0.2,0-0.2,0v0.1l-2.2,2.2 C25.7,31.8,25.7,31.9,25.8,32.1z"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#A1A1A1",
  d: "M30.6,27.8c0.2-0.2,0.2-0.4,0-0.5c-0.2-0.1-0.3-0.2-0.5,0l-1.4,1.4c-0.1,0.1-0.1,0.4,0,0.5h0.5L30.6,27.8z"
}));

function SvgWindow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    width: "45px",
    height: "45px",
    viewBox: "0 0 45 45",
    enableBackground: "new 0 0 45 45",
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgWindow);
export default __webpack_public_path__ + "static/media/window.2ae83de3e933c9ded09ca7277d0b2b68.svg";
export { ForwardRef as ReactComponent };